import { render, staticRenderFns } from "./BusinessOwner.vue?vue&type=template&id=1392a8ab&scoped=true&"
import script from "./BusinessOwner.vue?vue&type=script&lang=js&"
export * from "./BusinessOwner.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOwner.vue?vue&type=style&index=0&id=1392a8ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1392a8ab",
  null
  
)

export default component.exports